import { IconProps } from "./types";

export const AlertIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
    >
      <path
        d="M11.65 13.7C11.65 14.4 11.05 15 10.35 15C9.65 15 9.05 14.4 9.05 13.7C9.05 13 9.65 12.4 10.35 12.4C11.05 12.4 11.65 13 11.65 13.7ZM11.35 10.6V6.7C11.35 6.1 10.95 5.7 10.35 5.7C9.75 5.7 9.35 6.1 9.35 6.7V10.6C9.35 11.2 9.75 11.6 10.35 11.6C10.95 11.6 11.35 11.2 11.35 10.6ZM20.15 17.1C20.75 16.1 20.75 14.9 20.15 13.9L13.15 1.6C12.55 0.6 11.55 0 10.35 0C9.15 0 8.15 0.6 7.55 1.6L0.45 13.8C-0.15 14.8 -0.15 16 0.45 17C1.05 18 2.05 18.6 3.25 18.6H17.35C18.55 18.6 19.55 18 20.15 17V17.1ZM9.35 2.6C9.65 2.1 10.15 2 10.35 2C10.55 2 11.05 2 11.35 2.6L18.45 14.8C18.75 15.3 18.55 15.8 18.45 16C18.35 16.2 18.05 16.6 17.45 16.6H3.25C2.65 16.6 2.35 16.2 2.25 16C2.15 15.8 1.95 15.3 2.25 14.8L9.35 2.6Z"
        fill={fillColor ?? "#D91C0B"}
      />
    </svg>
  );
};
